import { State } from '../../types';

export const indiana: State = {
  name: 'Indiana',
  abbreviation: 'IN',
  terms: [
    {
      word: 'Cayuga',
      phonetic: 'KYE-oo-guh',
      // audioUrl: '/audio/cayuga.mp3',
      description: 'A town in Vermillion County, pronounced "KYE-oo-guh," not "KAY-you-guh."'
    },
    {
      word: 'Lafayette',
      phonetic: 'LAH-fee-ET',
      // audioUrl: '/audio/lafayette_in.mp3',
      description: 'A city in Tippecanoe County.'
    },
    {
      word: 'Loogootee',
      phonetic: 'luh-GOH-tee',
      // audioUrl: '/audio/loogootee.mp3',
      description: 'A city in Martin County, pronounced "luh-GOH-tee," not "LOO-goo-tee."'
    },
    {
      word: 'Peru',
      phonetic: 'Pee-ROO',
      // audioUrl: '/audio/peru_in.mp3',
      description: 'A city in Miami County.'
    },
    {
      word: 'Russiaville',
      phonetic: 'ROO-shuh-vil',
      // audioUrl: '/audio/russiaville.mp3',
      description: 'A town in Howard County, pronounced "ROO-shuh-vil," not "RUSS-ee-uh-vil."'
    },
    {
      word: 'Salamonie',
      phonetic: 'SAL-uh-MO-nee',
      // audioUrl: '/audio/salamonie.mp3',
      description: 'A river and reservoir, pronounced "SAL-uh-MO-nee," not "SAL-uh-MOH-nee."'
    },
    {
      word: 'Terre Haute',
      phonetic: 'TEHR-uh HOHT',
      // audioUrl: '/audio/terrehaute.mp3',
      description: 'City in western Indiana'
    },
    {
      word: 'Versailles',
      phonetic: 'ver-SALES',
      // audioUrl: '/audio/versailles-in.mp3',
      description: 'Town in southeastern Indiana'
    }
  ]
};